import React from 'react';
import PropTypes from 'prop-types';
import TagManager from 'react-gtm-module';

const GoogleAnalytics = class extends React.Component {
  static logPageChange = () => {
    const tagManagerArgs = {
      dataLayer: {
        event: 'ReactPageView',
        virtualPageURL: window.location.href,
        virtualPageTitle: document.title,
      },
      dataLayerName: 'PageDataLayer',
    };
    TagManager.dataLayer(tagManagerArgs);
  }

  componentDidMount() {
    if (window && document) GoogleAnalytics.logPageChange();
  }

  componentDidUpdate({ location: prevLocation }) {
    const { location: { pathname, search } } = this.props;
    const isDifferentPathname = pathname !== prevLocation.pathname;
    const isDifferentSearch = search !== prevLocation.search;

    if (isDifferentPathname || isDifferentSearch) {
      GoogleAnalytics.logPageChange(pathname, search);
    }
  }

  render() {
    return null;
  }
};

GoogleAnalytics.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string,
    search: PropTypes.string,
  }).isRequired,
};

export default GoogleAnalytics;



// WEBPACK FOOTER //
// ./src/components/ui/AnalyticsComponent.js